export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd" stroke="${color}" stroke-width="1.6">
        <path stroke-dasharray="3,2" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
        <circle cx="12" cy="12" r="6"/>
    </g>
</svg>
`
